import { createFileRoute } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../../../../../api/client'
import { UserTokensPage } from '../../../../../components/UserTokensPage'

// A member's sessions in this organization, for an org admin (spec
// 2026-10-01-01 §D): the same session cards as the user's own page, with
// "log out everywhere" for that member instead of "kill other sessions".
export const Route = createFileRoute('/$org/settings/members/$userUid/sessions')({
  component: MemberSessionsRoute,
})

function MemberSessionsRoute() {
  const { org, userUid } = Route.useParams()
  const { data: member } = useQuery({
    queryKey: ['member', org, userUid],
    queryFn: async () => {
      const { data, error } = await apiClient.GET('/api/v1/organizations/{orgCode}/members/{userUid}', {
        params: { path: { orgCode: org, userUid } },
      })
      if (error) throw new Error('Failed to load member')
      return data
    },
  })
  const label = member?.user?.name || member?.user?.email || ''
  return (
    <div className="container mx-auto py-8 max-w-4xl" data-testid="member-sessions-page">
      <UserTokensPage orgCode={org} userUid={userUid} mode="member" memberLabel={label} />
    </div>
  )
}
